import { apiHelper } from '../utils/requestHelpers';

export default {
  postPhoto({ photo, team }) {
    const data = new FormData();
    data.append('photo', photo);
    data.append('team', team);
    return apiHelper.post('/restapi/v1/admin/upload/photo', data);
  },
  postMedia({
    media, team, platform, type
  }) {
    const data = new FormData();
    data.append('media', media);
    data.append('team', team);
    data.append('platform', platform);
    data.append('type', type);
    return apiHelper.post('/restapi/v1/admin/upload/media', data);
  },
  postImageMapPhoto({ photo, team }) {
    const data = new FormData();
    data.append('photo', photo);
    data.append('team', team);
    return apiHelper.post('/restapi/v1/admin/upload/imagemap-photo', data);
  }
};
